/** Closes, or steps back from, one thing on screen. */
export type BackStep = () => void;

const steps: BackStep[] = [];

/**
 * Takes a step off the stack wherever it sits, so whatever closes in the
 * middle leaves the rest in order. A step that is not there is ignored, which
 * keeps the cleanup `pushBackStep` returns safe to call more than once.
 */
const leave = (step: BackStep): void => {
    const index = steps.indexOf(step);
    if (index !== -1) steps.splice(index, 1);
};

/**
 * Puts what just opened on top of what back answers to, and returns the call
 * that takes it off again. A step already in place moves to the top.
 */
export const pushBackStep = (step: BackStep): (() => void) => {
    leave(step);
    steps.push(step);

    return () => leave(step);
};

/**
 * Steps back from what opened last. False when nothing is open that knows how,
 * so the caller decides what back means then.
 */
export const stepBack = (): boolean => {
    const step = steps[steps.length - 1];
    if (!step) return false;

    step();
    return true;
};
